const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const CPAPI = `//m-cpapi${spell}.xinli001.com/cp/service/`,
  HCP = `//hcp${spell}.xinli001.com/`,
  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  APIS = {
    htpViewReport: `${CPAPI}fsr/viewReport`, // 查看房树人测评报告
    scaleModulesMsg: `${CPAPI}report/getScaleModulesMsg`, // 获取报告模块 id
    htpUploadImage: `${HCP}fsr/uploadImage`, //  上传房树人测评图片
    fetchPoster: `${HCP}fsr/fetchPoster`, //  获取房树人分享海报
    fetchTeacher: `${HCP}fsr/fetchTeacher`, //  获取房树人咨询师资料
    authHouseTreeHuman: `${LXDOMAIN}houseTreeHuman/auth`, //房树人报告页授权接口
    generalUploadImage: `${HCP}common/uploadImage/bindAccountId`, //  上传测试的图片
    yzrViewReport: `${CPAPI}yzr/viewReport`, // 查看雨中人测评报告
  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/houseTreePeople.js